import * as z from 'zod';

export const TypeSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  updated_at: z.string(),

  name: z
    .string({
      message: 'Unit name is required!',
    })
    .min(3, {
      message: 'Unit name must be at least 3 characters!',
    }),
});

export type TypeSchemaType = z.infer<typeof TypeSchema>;

export const CreateTypeSchema = TypeSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
});

export type CreateTypeSchemaType = z.infer<typeof CreateTypeSchema>;
